import { SectionLabel } from "../SectionLabel";
import { StatCard } from "./StatCard";

const stats = [
  { title: "Ready to Spend.", description: "High-intent shoppers looking for their next purchase." },
  { title: "Ready to Return.", description: "Customers ready to follow your brand and return often." },
  { title: "Local Reach", description: "Connect directly with locals actively exploring your area." },
];

export const CustomerStatsSection = () => {
  return (
    <section className="w-full px-[16px] sm:px-6 lg:px-[80px] pt-10 lg:pt-[42px]">
      <div className="relative mx-auto w-full max-w-[1620px] overflow-hidden rounded-[28px] lg:rounded-[48px] bg-[linear-gradient(180deg,#3E3E3E_0%,#2E2E2E_100%)] px-[20px] sm:px-10 lg:px-[105px] py-12 lg:py-[70px] text-center">
        <img
          src="/images/group.svg"
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 w-full h-full object-cover opacity-70"
        />

        <div className="relative z-10">
          <SectionLabel tone="light">Deals by Category</SectionLabel>

          <h2 className="mt-6 lg:mt-8 text-white font-normal leading-[1.2] tracking-[-1px] text-[30px] sm:text-[42px] lg:text-[64px]">
            Your Customers Are
            <br />
            Waiting For You
          </h2>

          <p className="mt-[20px] lg:mt-8 mx-auto max-w-[830px] text-white/90 text-[14px] sm:text-[16px] lg:text-[20px] leading-[1.35]">
            Thousands of locals use our app daily to decide where to spend. Publish your first offer today and bring
            them through your door.
          </p>

          <div className="mt-10 lg:mt-[88px] grid grid-cols-1 xl:grid-cols-3 gap-[16px] lg:gap-6 xl:gap-8">
            {stats.map((stat) => (
              <StatCard key={stat.title} title={stat.title} description={stat.description} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
